<template>
  <b-container fluid v-if="itemsLoaded">
    <div class="text-center mt-5" id="iconImage">
      <b-avatar size="6rem" :src="item.icon"></b-avatar>

      <h3 class="text-light mt-2">{{ item.name }}</h3>
    </div>

    <div class="information">
      <b-row>
        <b-col
          md="3"
          sm="6"
          v-for="information in info"
          v-bind:key="information.id"
        >
          <template v-if="information == 'perfectPrice'">
            <template v-if="item.perfectPrice">
              <b-card class="card">
                <b-card-title>
                  {{ information }}
                </b-card-title>
                <b-card-text>
                  Approx. perfect price: {{ item.perfectPrice }}
                  <b-img
                    src="https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyRerollRare.png?v=c60aa876dd6bab31174df91b1da1b4f9"
                    height="24"
                    width="24"
                    class="mr-1"
                  ></b-img>
                </b-card-text>
              </b-card>
            </template>
          </template>
          <template v-else>
            <b-card class="card">
              <b-card-title>
                {{ information }}
              </b-card-title>
              <b-card-text>
                {{ item[information] }}
                <template
                  v-if="
                    information != 'daily' &&
                    information != 'category' &&
                    information != 'group'
                  "
                >
                  <b-img
                    src="https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyRerollRare.png?v=c60aa876dd6bab31174df91b1da1b4f9"
                    height="24"
                    width="24"
                    class="mr-1"
                  ></b-img>
                </template>
              </b-card-text>
            </b-card>
          </template>
        </b-col>
      </b-row>
    </div>

    <div class="info-data">
      <b-row>
        <b-col cols="12">
          <div>
            <b-tabs
              content-class="mt-3"
              lazy
              justified
              active-nav-item-class="active-tab"
            >
              <b-tab title="History" active>
                <div class="text-light mt-2">
                  <line-chart v-if="loaded" :chart-data="chartdata" /></div
              ></b-tab>
              <template v-if="enchants">
                <b-tab title="Enchants"
                  ><div class="text-light">
                    <b-table
                      dark
                      sort-by="value"
                      :sort-desc="true"
                      :items="enchantItems"
                      sticky-header="50vh"
                      :fields="fields"
                      no-border-collapse
                    >
                      <template v-slot:cell(name)="data">
                        <template v-if="data.item.lowConfidence">
                          <span style="color: #e57373">{{
                            data.item.name
                          }}</span>
                        </template>
                        <template v-else>{{ data.item.name }}</template>
                      </template>

                      <template v-slot:cell(value)="data">
                        {{ data.item.value }}
                        <b-img
                          src="https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyRerollRare.png?v=c60aa876dd6bab31174df91b1da1b4f9"
                          height="32"
                          width="28"
                          class="mr-1"
                        ></b-img>
                      </template>
                    </b-table>
                  </div>
                </b-tab>
              </template>
              <template v-if="corruptions.length > 0">
                <b-tab title="Corruptions">
                  <div class="text-light">
                    <b-table
                      dark
                      hello
                      sort-by="mean"
                      :sort-desc="true"
                      sticky-header="50vh"
                      no-border-collapse
                      :items="corruptions"
                    >
                        <template v-slot:cell(mean)="data">
                        {{ data.item.mean }}
                        <b-img
                          src="https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyRerollRare.png?v=c60aa876dd6bab31174df91b1da1b4f9"
                          height="32"
                          width="28"
                          class="mr-1"
                        ></b-img>
                      </template>
                    
                    </b-table>
                  </div>
                </b-tab>
              </template>
              <template v-if="item.implicits || item.explicits">
                <b-tab title="Mods">
                  <div class="text-light">
                    <b-row>
                        <template v-if="item.implicits">
                          <b-col>
                            <h4>Implicits</h4>
                            <li v-for="item in item.implicits" :key="item.id">
                              {{ item }}
                            </li>
                          </b-col>
                        </template>
                        <template v-if="item.explicits">
                          <b-col>
                            <h4>Explicits</h4>
                            <li v-for="item in item.explicits" :key="item.id">
                              {{ item }}
                            </li>
                          </b-col>
                        </template>
                    </b-row>
                  </div>
                </b-tab>
              </template>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import LineChart from "../components/LineChart";
export default {
  name: "DetailedPage",
  components: { LineChart },
  data() {
    return {
      chartdata: [],
      itemsLoaded: false,
      loaded: false,
      icon: "",
      enchantItems: {},
      item: {},
      enchants: false,
      fields: [
        {
          key: "name",
          sortable: false,
        },
        {
          key: "value",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      info: [
        "mean",
        "min",
        "max",
        "daily",
        "category",
        "group",
        "perfectPrice",
      ],
      modals: ["implicits", "explicits", "enchants", "corruptions"],
      corruptions: [],
    };
  },
  mounted() {
    let id = this.$route.params.id;
    let league = this.$parent.league;
    this.init(id, league);
  },
  methods: {
    init(id, league) {
      this.getItem(id, league);
      this.getEnchants(id, league);
      this.getCorruptions(id, league)
    },

    getLineChart(id, league) {
      axios
        .get("https://api.poe.watch/history?id=" + id + "&league=" + league)
        .then((response) => {
          this.labels = response.data.map((item) => {
            var d = new Date(item.date);
            var curr_date = d.getDate();
            var curr_month = d.getMonth() + 1; //Months are zero based
            var curr_year = d.getFullYear();
            curr_date = curr_date < 10 ? "0" + curr_date : curr_date;
            curr_month = curr_month < 10 ? "0" + curr_month : curr_month;
            return curr_date + "." + curr_month + "." + curr_year;
          });
          let means = response.data.map((item) => item.mean);

          this.chartdata = {
            labels: this.labels,

            datasets: [
              {
                label: this.item.name,
                borderWidth: 1,
                fill: true,
                data: means,
                borderColor: "#3cba9f",
              },
            ],
          };
          this.loaded = true;
        });
    },
    getEnchants(id, league) {
      axios
        .get("https://api.poe.watch/enchants?id=" + id + "&league=" + league)
        .then((response) => {
          this.enchantItems = response.data;
          if (this.enchantItems) {
            this.enchants = true;
          }
        });
    },
    getItem(id, league) {
      axios
        .get("https://api.poe.watch/id?id=" + id + "&league=" + league)
        .then((response) => {
          this.item = response.data;
          this.getLineChart(id, league);
          this.itemsLoaded = true;
        });
    },
    getCorruptions(id, league){
       axios
        .get("https://api.poe.watch/corruptions?id=" + id + "&league=" + league)
        .then((response) => {
          if (response.data != null && response.data.length > 0){
            this.corruptions = response.data
          }
        });
    }
  },
  watch: {
    $route(to) {
      let league = this.$parent.league;
      this.init(to.params.id, league);
    },
  },
};
</script>

<style>
#mods {
  background-color: #2c3e50;
  height: 100%;
  font-size: 1.1rem;
}

.card {
  background-color: var(--dark);
  color: white;
  margin-bottom: 10px;
}

.active-tab {
  color: #42b983 !important;
  background-color: var(--dark) !important;
}
/* .nav-link{
  border-color: #e9ecef #e9ecef #dee2e6 !important;
} */
a {
  color: white;
}
</style>